"use strict"

import { getMapIdFromName } from "../shared/utils"

export default function routes($stateProvider) {
  "ngInject"

  $stateProvider.state("surroundings", {
    url: "/surroundings/:mapid",
    component: "surroundings",
    resolve: {
      campsitedata: (dataService, $stateParams) => dataService.getData(getMapIdFromName($stateParams.mapid)),
    },
  })
}
